(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);


    const menuToggle = document.querySelector('#drawer-menu-toggle');

    menuToggle.addEventListener('click', function(event) {
      menuToggle.setAttribute('aria-expanded', document.body.classList.toggle('menu-open'));
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["row-can_highlights"] && !Shopify.designMode) return;
  try {
    

    function countUpAndDown(start, end, duration, easingFunction) {
        let count = start;
        let direction = 1; // Start counting up
        let intervalId;

        function updateCount() {
            const canSpin = document.getElementById('tilted-can');
            canSpin.src = "/cdn/shop/files/img-easyman-can-" + count + ".png";

            if ((direction === 1 && count >= end) || (direction === -1 && count <= start)) {
                direction *= -1; // Change direction
            }
            count += direction;
        }

        intervalId = setInterval(updateCount, duration / Math.abs(end - start));

        return function stopCounter() {
            clearInterval(intervalId);
        };
    }

    const canSpinner = countUpAndDown(0, 12, 1500, (t) => t);

    // setTimeout(canSpinner, 10000);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["row-product-ingredients"] && !Shopify.designMode) return;
  try {
    

    const infoTab = document.getElementById('info-tab');
    const ingredientTab = document.getElementById('ingredients-tab');
    const infoContent = document.getElementById('info-content');
    const ingredientContent = document.getElementById('ingredients-content');

    infoTab.addEventListener("click", function() {
        infoTab.classList.add('active');
        infoContent.classList.add('active');
        ingredientTab.classList.remove('active');
        ingredientContent.classList.remove('active');
    })

    ingredientTab.addEventListener("click", function() {
        ingredientTab.classList.add('active');
        ingredientContent.classList.add('active');  
        infoTab.classList.remove('active');
        infoContent.classList.remove('active');     
    })


  } catch(e) { console.error(e); }
})();
})();
